import {
  IProductHier,
  IGlobalProduct,
  IColor,
  IMarketingMaterial,
  IDecorationTech,
  IDesign,
  IChannel,
  IFlavorScent,
  ILicensor,
  ILicensedProperty,
  ITcc,
  IConsumerType,
  IPlugType,
} from "../../types/data.interface";
import { Action } from "../../types/state/action";
import { MasterArtworkNameState } from "../meta-artwork/artwork-name/data.type";
import { MasterArtworkCollectionState } from "../meta-artwork/collections/data.type";

type ValueOrNull<T> = T | null;

export type Option<T> = { value: T; label: string };

export type ItemNumberSearchesState = {
  newGlobalProduct: ValueOrNull<IGlobalProduct>;
  itn_itemno: string;
  itn_itemnm: string;
  category: ValueOrNull<IProductHier>;
  subCategory: ValueOrNull<IProductHier>;
  productLine: ValueOrNull<IProductHier>;


  itn_cptype: ValueOrNull<IConsumerType>;
  itn_cplang: string;
  itn_cpgcod: string;
  itn_cpgnam: string;
  itn_inclfm: ValueOrNull<Option<string>>;
  itn_lfmnum: string;
  itn_lfmnam: string;
  itn_plgtyp: ValueOrNull<IPlugType>;
  itn_plgnam: string;
  itn_restri: string;
  itn_lifsts: ValueOrNull<Option<string>>;
  itn_ean13d: string;
  itn_upc12d: string;
  itn_mfpnum: string;
  itn_relsdt: string;
  itn_reqmkt: ValueOrNull<IMarketingMaterial>;
  marketing_material_id: any;
};

export enum ItemNumberSearchesActionTypes {
  SET_PLACEHOLDER = "itemnumberSearches/setPlaceholder",
  SET_NEW_GLOBAL_PRODUCT = "itemnumberSearches/setNewGlobalProduct",
  SET_NEW_ITEM_NUMBER = "itemnumberSearches/setNewItemNumber",

  SET_CONSUMER_PACKAGING_TYPE = "itemnumberSearches/setCPtype",
  SET_CONSUMER_PACKAGING_LANGUAGE = "itemnumberSearches/setCPlang",
  SET_CONSUMER_PACKAGING_GLOBAL_CODE = "itemnumberSearches/setCPgcod",
  SET_CONSUMER_PACKAGING_GLOBAL_NAME = "itemnumberSearches/setCPgnam",
  SET_CATEGORY = "tccSearches/setCategory",
  SET_SUB_CATEGORY = "tccSearches/setSubCategory",
  SET_PRODUCT_LINE = "tccSearches/setProductLine",

  SET_INCLUDES_LEAFLET_MANUAL = "itemnumberSearches/setInclfm",
  SET_INCLUDES_LEAFLET_NUMBER = "itemnumberSearches/setLfmnum",
  SET_INCLUDES_LEAFLET_NAME = "itemnumberSearches/setLfmnam",
  SET_MARKETING_MATERIAL = "itemnumberSearches/setMarketingMaterial",
  SET_PLUG_TYPE = "itemnumberSearches/setPlgtyp",
  SET_PLUG_NAME = "itemnumberSearches/setPlgnam",
  SET_UPC12 = "itemnumberSearches/setMfpnum",
  SET_EAN13D = "itemnumberSearches/setEAN13D",
  SET_REGULATORY_RESTRICTIONS = "itemnumberSearches/setRestri",
  SET_RELEASE_DATE = "itemnumberSearches/setRelsdt",
  SET_LINE_PLANNING_STATUS = "itemnumberSearches/setLinePlanningStatus",

  SET_FILTERS_FROM_STORAGE = "itemnumberSearches/setFiltersFromStorage",
  RESET = "itemnumberSearches/reset",
}

export type ItemNumberSearchesActionType = Action<
  ItemNumberSearchesActionTypes,
  Partial<ItemNumberSearchesState>
>;
